// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14323":"05102e54","15261":"ceb3ef8d","21437":"c79086ad","37454":"c79086ad","49507":"05102e54","92421":"05102e54"}[chunkId] + ".chunk.css";
};